import { render, staticRenderFns } from "./performance-measure.vue?vue&type=template&id=41e4b7fe"
import script from "./performance-measure.vue?vue&type=script&lang=js"
export * from "./performance-measure.vue?vue&type=script&lang=js"
import style0 from "./performance-measure.vue?vue&type=style&index=0&id=41e4b7fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports